<template>
  <div class="page-content prose">
    <div class="container">
      <h1>Informatie over cv-installaties</h1>
      <p>
        Bent u op zoek naar een nieuwe cv-installatie? Wilt u uw huis
        gemakkelijker en duurzamer verwarmen? Dan kunt u nu vrijblijvende
        informatie en prijsopgaves aanvragen, zodat u zelf voor de beste optie
        kunt kiezen.
      </p>

      <h2>Een cv-installatie aanschaffen?</h2>
      <p>
        Wat is voor u belangrijk voor het installeren van een nieuwe
        cv-installatie? Omdat geen huis precies hetzelfde is zijn er voor elk
        huis ook weer verschillende oplossingen op maat. Om u alvast wat op weg
        te helpen hebben we hieronder een paar veel voorkomende keuzes en hun
        voordelen op een rijtje gezet. Als gevolg van de Warmtewet en de nieuwe
        ERP richtlijnen, zijn alle CV Ketels met een energielabel uitgerust. CV
        ketels met een label hoger dan niveau B, mogen vanaf september 2015 niet
        meer worden verkocht. Voor VR ketels, standaard uitgerust met een label
        C, is dus het doek gevallen. Deze zogenaamde ketels met verbeterd
        rendement zijn volgens de Europese regels namelijk niet zuinig genoeg.
        VR-ketels moeten daarom standaard vervangen worden voor een HR ketel.
        Uitzonderingen kunnen zich voordoen indien de bestaande rookgasafvoer
        niet kan worden vervangen of er zich problemen voordoen met de
        condensafvoer.
      </p>

      <h2>HR ketel</h2>
      <p>
        De “Hoog Rendement ketel” is de meest gebruikte ketel in Nederland.
        Omdat deze cv ketel erg energiezuinig is en u dus minder gas gebruikt,
        bespaart u geld op uw gasrekening. De beste HR ketels behalen momenteel
        een rendement van 107% door het hergebruiken van waterdampen bij de
        verbranding. Een HR ketel is duurder in aanschaf dan een normale ketel,
        echter door de energiebesparing worden de extra kosten binnen 15 jaar
        terugverdiend. Het rendement van uw eigen ketel is altijd terug te
        vinden op de gaskeur sticker.
      </p>

      <h2>HR combi ketel</h2>
      <p>
        De naam “combi ketel” zegt het eigenlijk al, naast de verwarming zorgt
        de combi ketel ook voor warm water. Hoeveel warm water een ketel
        tegelijk kan leveren wordt aangeduid middels CW-waarde. Hiervoor geldt
        de regel; waarde CW1 levert 2 liter warm water per minuut en een CW2
        levert 4 liter warm water enz.
      </p>

      <h2>VR ketel</h2>
      <p>
        Een “verbeterd rendement ketel” is het minder zuinige alternatief van de
        HR ketel. Een VR ketel heeft een gemiddeld rendement tussen de 75% en
        85%. Ook een VR ketel is er in solo en combi uitvoering, dat werkt
        hetzelfde als bij de HR ketel.
      </p>

      <h2>Radiatoren</h2>
      <p>
        Radiatoren zijn nog steeds het populairst als het gaat om het verwarmen
        van uw woning. Bepalen hoeveel radiatoren u nodig heeft voor bepaalde
        ruimtes is echter een moeilijke opgave. Het benodigde vermogen van de
        radiator is als volgt te berekenen. Een voorbeeld van de gewenste
        temperatuur en benodigde capaciteit per ruimte:
      </p>
      <t-table>
        <thead>
          <tr>
            <th>Ruimte</th>
            <th>Temperatuur</th>
            <th>Watt per m3</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Hal</td>
            <td>18 graden</td>
            <td>70 watt</td>
          </tr>
          <tr>
            <td>Toilet</td>
            <td>18 graden</td>
            <td>70 watt</td>
          </tr>
          <tr>
            <td>Slaapkamer</td>
            <td>18 graden</td>
            <td>70 watt</td>
          </tr>
          <tr>
            <td>Keuken</td>
            <td>20 graden</td>
            <td>77 watt</td>
          </tr>
          <tr>
            <td>Woonkamer</td>
            <td>22 graden</td>
            <td>85 watt</td>
          </tr>
          <tr>
            <td>Badkamer</td>
            <td>24 graden</td>
            <td>93 watt</td>
          </tr>
        </tbody>
      </t-table>
      <p>
        Vervolgens kunt u met de volgende formule de benodigde capaciteit van de
        radiatoren berekenen: lengte x breedte x hoogte x Watts per m3 = Watt
        (vermogen radiator)
      </p>

      <h2>Vloerverwarming</h2>
      <p>
        Wat steeds vaker terugkomt is vloerverwarming als primaire verwarming in
        huis. Dit heeft als voordeel dat u in huis geen last meer heeft van
        radiatoren omdat alle verwarming simpelweg in de vloer is verwerkt.
        Omdat vloerverwarming wel een goede isolatie van de vloer vereist, is
        het raadzaam om in oudere slechter geïsoleerde huizen toch voor de
        traditionele radiator te kiezen. Slechter geïsoleerde vloeren kunnen bij
        vloerverwarming namelijk veel verlies aan warmte tot gevolg hebben.
      </p>

      <h2>Vrijblijvend CV advies aanvragen?</h2>
      <p>
        Benieuwd geworden naar de mogelijkheden voor uw huis? Als u de voordelen
        en de prijzen van de verschillende cv-installaties wilt vergelijken,
        kunt u hier een
        <nuxt-link to="/"> aanvraag </nuxt-link>
        indienen.&nbsp;
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een cv-installateur?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
